import { useCallback } from "react";
import { Headset } from "lucide-react";

import { getNextQueryParams } from "components/helpers";
import usePageTitle from "hooks/usePageTitle";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import CallQueueService from "services/CallQueue";
import {
  invalidateAgentDashboardTableQuery,
  useAgentDashboardTable,
} from "hooks/useAgentDashboardTable";

export const AGENT_DASHBOARD_TABLE_CONSTANTS = {
  tableName: "agent_dashboard",
  queryKey: "agent-dashboard",
  className: "agent_dashboard",
  header: "Agent Dashboard",
  headerIcon: Headset,
};

const AgentDashboardTableV3 = () => {
  usePageTitle(AGENT_DASHBOARD_TABLE_CONSTANTS.header);

  const { filters, columns, lastUpdate } = useAgentDashboardTable();

  const fetchAgentDashboard = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await CallQueueService.getAgentDashboardTable(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching agent dashboard:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      lastUpdate={lastUpdate}
      headerIcon={AGENT_DASHBOARD_TABLE_CONSTANTS.headerIcon}
      header={AGENT_DASHBOARD_TABLE_CONSTANTS.header}
      tableName={AGENT_DASHBOARD_TABLE_CONSTANTS.tableName}
      queryKey={AGENT_DASHBOARD_TABLE_CONSTANTS.queryKey}
      className={AGENT_DASHBOARD_TABLE_CONSTANTS.className}
      fetchData={fetchAgentDashboard}
      invalidateData={invalidateAgentDashboardTableQuery}
      enableSearch
      enableSettings
    />
  );
};

export default AgentDashboardTableV3;
